__turbopack_context__.v({
  "button-container": "CoreButton-module-scss-module__B1MHcG__button-container",
});
